import { useEffect, useState } from 'react';
import { listInstagramRefs } from '../lib/firestore';
import { normalizeInstagramUrl } from '../lib/social';

export default function InstagramPreview() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const profileUrl = normalizeInstagramUrl(import.meta.env.VITE_INSTAGRAM_PROFILE_URL);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const graphUserId = import.meta.env.VITE_INSTAGRAM_GRAPH_USER_ID;
        const graphToken = import.meta.env.VITE_INSTAGRAM_GRAPH_ACCESS_TOKEN;
        const graphVersion = import.meta.env.VITE_INSTAGRAM_GRAPH_VERSION || 'v23.0';

        if (graphUserId && graphToken) {
          const endpoint = `https://graph.facebook.com/${graphVersion}/${graphUserId}/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&limit=6&access_token=${encodeURIComponent(graphToken)}`;
          const res = await fetch(endpoint);
          if (res.ok) {
            const json = await res.json();
            const rows = (json.data || [])
              .map((item) => ({
                id: item.id,
                url: item.permalink,
                caption: item.caption || 'Instagram post',
                coverImageUrl:
                  item.media_type === 'VIDEO'
                    ? item.thumbnail_url || item.media_url
                    : item.media_url,
              }))
              .filter((item) => item.url && item.coverImageUrl);

            if (rows.length) {
              setItems(rows);
              setLoading(false);
              return;
            }
          }
        }

        const rows = await listInstagramRefs(6);
        setItems(
          rows
            .map((row) => ({
              id: row.id,
              url: normalizeInstagramUrl(row.url),
              caption: row.caption || 'Instagram post',
              coverImageUrl: row.coverImageUrl,
            }))
            .filter((item) => item.url && item.coverImageUrl)
        );
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) {
    return (
      <div className="instagram-grid" aria-label="Instagram読み込み中">
        {Array.from({ length: 6 }).map((_, index) => (
          <div className="skeleton-card insta-skeleton" key={`insta-skeleton-${index}`} aria-hidden="true" />
        ))}
      </div>
    );
  }

  if (!items.length) {
    return (
      <p className="insta-note">
        投稿を取得できませんでした。<a href={profileUrl} target="_blank" rel="noreferrer">Instagramプロフィールを見る</a> / 次回更新予定をご確認ください。
      </p>
    );
  }

  return (
    <div className="instagram-grid" role="list" aria-label="Instagram投稿プレビュー">
      {items.map((item) => (
        <a
          key={item.id}
          role="listitem"
          href={normalizeInstagramUrl(item.url)}
          target="_blank"
          rel="noreferrer"
          className="instagram-card"
        >
          <img src={item.coverImageUrl} alt={item.caption} loading="lazy" />
        </a>
      ))}
    </div>
  );
}
